export default __webpack_public_path__ + "static/media/react.05e48353.png";